import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { RolePrevExpValue } from '@/components/Forms/QuestionType/CrewType';
import CrewTimeInput from '@/components/Forms/QuestionType/CrewTimeInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewExtraRow',
  props: {
  value: {
    type: Object as PropType<RolePrevExpValue>,
    required: true,
  },
  ranks: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
},
  emits: {
  input: (value: RolePrevExpValue) => value && true,
  remove: () => true,
},
  setup(__props, { emit }) {

const props = __props;




function modelValueObjKey(key: string, props, emit) {
  return computed({
    get() {
      return props.value[key];
    },
    set(v) {
      emit('input', { ...props.value, [key]: v });
    },
  });
}

const rank = modelValueObjKey('rank', props, emit);
const size = modelValueObjKey('size', props, emit);
const time = modelValueObjKey('time', props, emit);

return { __sfc: true,props, emit, modelValueObjKey, rank, size, time, CrewTimeInput }
}

})